import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  FilesListResponse,
  FileUploadResponse,
} from "@oracus/shared/api/files";

import { apiClient } from "./client.ts";

export function useFiles() {
  return useQuery({
    queryKey: ["files"],
    queryFn: () => apiClient.get("/api/files", FilesListResponse),
  });
}

export function useUploadFile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file: File) =>
      apiClient.upload("/api/files/upload", file, FileUploadResponse),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["files"] });
    },
  });
}
